export const getSearchCondition = (values: (string | null | undefined)[], search?: string[]): boolean => {
  // mark as matching if there is nothing to check
  if (!search || search.length === 0) {
    return true
  }
  const lowercaseValues = values.filter((value) => value != null).map((value) => value.toLowerCase())
  const lowercaseKeywords = search.map((keyword) => keyword.toLowerCase())
  return lowercaseValues.some((value) => lowercaseKeywords.some((keyword) => value.includes(keyword)))
}

export const getValueCondition = <T>(value: T, search?: T[]): boolean => {
  // mark as matching if there is nothing to check
  if (!search || search.length === 0) {
    return true
  }
  return search.includes(value)
}
